//
//
//
//
//
//
//
//

import copyrightMessage from '@/components/copyrightMessage';
export default {
  name: 'App',
  components: {
    copyrightMessage: copyrightMessage
  },
  created: function created() {
    this.$store.dispatch("app/setTitle");
  }
};